import axios from 'axios'

export default {

    fetchTimetablesByDates(start, end) {
        return axios.get('timetables/bydates?start=' + start + '&end=' + end).then(response => {
            return response.data
        })
    },

    fetchTimetableByDates(start, end, id, canceled) {
        let query = {'start': start, 'end': end}
        if (canceled) query['canceled'] = 1
        if (id) query['timetable_id'] = id

        const queryParams = new URLSearchParams(query);
        let uri = 'timetables/bydates?' + queryParams.toString();

        return axios.get(uri).then(response => {
            return response.data
        })
    },

    fetchMyTimetableByDates(start, end, canceled) {
        let query = {'start': start, 'end': end}
        if (canceled) query['canceled'] = 1

        const queryParams = new URLSearchParams(query);
        let uri = 'timetables/my-bydates?' + queryParams.toString();

        return axios.get(uri).then(response => {
            return response.data
        })
    },

    fetchTimetables() {
        return axios.get('timetables').then(response => {
            return response.data
        })
    },

    fetchTimetable(id) {
        return axios.get('timetables/' + id).then(response => {
            return response.data
        })
    },

    fetchTimetableLesson(id) {
        return axios.get('timetables/lesson/' + id).then(response => {
            return response.data
        })
    },

    async fetchTimetableLessonAsync(id) {
        const response = await axios.get('timetables/lesson/' + id)
        return response.data
    },

    async markVisitLessonAsync(lessonId) {
        const response = await axios.get('timetables/mark-visit-lesson/' + lessonId)
        return response.data
    },

    fetchMyTimetables() {
        return axios.get('timetables/user').then(response => {
            return response.data
        })
    },

    assignTimetables(id) {
        return axios.post('timetables/assign', {timetable_id: id}).then(response => {
            return response.data
        })
    },

    createEntry(name, phone, email, comment, clientId, url) {
        return axios.post('timetables/entry', {
            name: name,
            phone: phone,
            email: email,
            comment: comment,
            clientId: clientId,
            url: url,
        }).then(response => {
            return response.data
        })
    },

    async fetchMyTokenAsync() {
        const response = await axios.get('timetables/my-token')
        return response.data
    },

}
